$(document).ready(function() {
  if (!$('.capacitor-component').length)
    return
  $('input[type=radio][name=plan]').change(function() {
      var link = document.getElementById('contact-button')
      window.linkToContact = window.linkToContact || link.href
      const splitLink = window.linkToContact.split('#')
      link.href = splitLink[0] + '?capacitor="' + this.value + '"' + '#' + splitLink[1]
      var $days = $('#capacitor-options-days')
      $days.css('width', $(this).attr('data-percentage') + '%')
      $('#capacitor-options-days-date').text($(this).attr('data-absolute-date') )
      $('#capacitor-long-date').text($(this).attr('data-absolute-date-long') )
  });
  $('input[type=radio][name=plan]:first').trigger('change')
})

// const capacitor = (function() {
//   if ($('.capacitor-component').length) {
//     const $capEl = $('.capacitor-component')
//     const $sliderSection = $capEl.find('.slider-section')
//     const $indicators = $sliderSection.find('.indicator')
//     const $red = $sliderSection.find('.red.indicator')
//     const $blue = $sliderSection.find('.blue.indicator')
//     const $baseLine = $sliderSection.find('.baseline')
//     const $redDesc = $red.find('.chevron .description')
//     const $blueDesc = $blue.find('.chevron .description')
//     const $dotDesc = $baseLine.find('.dot').find('.description')
//
//     var dates = []
//
//
//     var daysInMonth = 30
//     var startDay = 5
//     var startMont = 10
//
//     /**
//       Capacitator expects array of dates (day and month) -> should be supplied by backend into dates[] variable
//       This only a for test purposes ---->
//     */
//     for (var i = startDay; i < 40 + startDay; i++) {
//       if (i <= daysInMonth) {
//         dates.push({
//           d: i,
//           m: startMont
//         })
//       } else {
//         dates.push({
//           d: i - daysInMonth,
//           m: startMont + 1
//         })
//       }
//     }
//     /*
//       <----
//     */
//
//     var dayCount = dates.length
//
//     /*
//       Date till the session is full
//     */
//     var full = {
//       d: 15,
//       m: 10
//     }
//
//     indicatorRed = new Indicator($red, $baseLine)
//     indicatorBlue = new Indicator($blue, $baseLine)
//     init()
//
//     function indexInDates(arg) {
//       for (var i = 0; i < dayCount; i++) {
//         if (arg.m == dates[i].m) {
//           if (arg.d == dates[i].d) return i
//         }
//       }
//       return 0
//     }
//
//     function init() {
//       var date = dates[0]
//       $dotDesc.html(date.d.toString() + "." + date.m.toString())
//         // red indicator
//       var index = indexInDates(full)
//       if (index === 0) {
//         // if full date is invalid it is treated as no full date and hides the red indicator
//         $red.hide()
//           // needed for blue indicator to know he has 100% of space available
//         indicatorRed.setWidth(0)
//       } else {
//         // calc the position of full date in the dates array and set width of red bar accordingly
//         var percent = index / (dayCount / 100)
//         indicatorRed.setWidth(percent)
//         $redDesc.html(full.d.toString() + "." + full.m.toString())
//       }
//       // blue indicator
//       var blueMax = (100 - indicatorRed.getWidth())
//       var blueMin = 7
//       indicatorBlue.setMax(blueMax).setDrag(true)
//       indicatorBlue.setMin(blueMin)
//       indicatorBlue.setWidth(blueMax / 2)
//       percent = indicatorBlue.getWidth()
//       date = dates[Math.round((dayCount / 100) * percent)]
//       $blueDesc.html(date.d.toString() + "." + date.m.toString())
//     }
//     /*
//       Main drag even on blue indicator
//     */
//     $blue.on('drag', function() {
//       var percent = indicatorBlue.getWidth() + indicatorRed.getWidth()
//       var calDate = Math.floor((dayCount / 100) * percent)
//       var date = dates[dayCount - 1]
//       if (calDate < dayCount - 1) {
//         date = dates[calDate]
//       }
//       $blueDesc.html(date.d.toString() + "." + date.m.toString())
//     })
//
//     $(window).resize(init)
//   }
// })()



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/capacitor.js